import { Link } from 'react-router'
import { useMediaQuery } from 'usehooks-ts'

import DesktopNav from './Components/NavLayout/DesktopNav'
import MobileNav from './Components/NavLayout/MobileNav'

import { cn } from '~/lib/utils'
import { cva } from 'class-variance-authority'

import { isDevelopment } from '~/utils/misc'
import UohLogo from '../icons/uoh_logo'

const backgroundColour = cva('', {
  variants: {
    colour: {
      'ink-blue': 'bg-blue-d text-white',
      'mid-blue': 'bg-blue-m text-white',
      'light-blue': 'bg-blue-l text-blue-d',
      chartreuse: 'bg-char text-blue-d',
      'light-pink': 'bg-pink text-blue-d',
      'light-aqua': 'bg-green text-blue-d',
      'light-purple': 'bg-purple text-blue-d',
      'light-orange': 'bg-orange text-blue-d',
      'light-grey': 'bg-grey-l text-blue-d',
      white: 'bg-white text-blue-d'
    }
  },
  defaultVariants: {
    colour: 'ink-blue'
  }
}) as (options: { colour?: AllBackgroundColours }) => string

const Header = ({ data, bgColour, ticker }: HeaderProps) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)', {
    defaultValue: true,
    initializeWithValue: false
  })
  const isMobile = useMediaQuery('(max-width: 1024px)', {
    defaultValue: true,
    initializeWithValue: false
  })

  const NavData = data
  const colour = bgColour

  return (
    <header
      className={cn(
        backgroundColour({ colour }),
        'sticky top-0 z-50 flex h-[70px] w-full items-center text-white sm:h-[90px]'
      )}
    >
      <div className='container flex items-center justify-between'>
        <Link
          to={`/${isDevelopment ? '?nodeId=7dbfda4f-5ffc-4a4f-883f-43dc4eb00222&entryId=7893812d-1bab-44e7-a1a4-45f07b924de3' : ''}`}
          aria-label='University of Hull homepage'
          className='unstyled-link sm:mr-l pointer-events-auto shrink-0'
          reloadDocument
        >
          <UohLogo
            fill={
              ['ink-blue', 'mid-blue'].includes(colour ?? '') ? 'white' : 'blue'
            }
            className={'block h-[40px] w-auto sm:h-[56px]'}
          />
        </Link>

        {isDesktop && (
          <div className='hidden lg:block'>
            <DesktopNav data={NavData} colour={colour} />
          </div>
        )}

        {isMobile && (
          <div className='block lg:hidden'>
            <MobileNav data={NavData} colour={colour} ticker={ticker} />
          </div>
        )}
      </div>
    </header>
  )
}

export default Header
